import '@/plugins/mob-share'
import api from '../api'
import { MOD_SHARE_KEY } from './constants'
import $ from 'jquery'

function isMobile () {
  const userAgentInfo = navigator.userAgent
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      return true
    }
  }
  return false
}

function isIOS () {
  return /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
}

function isAndroid () {
  return /android|linux/.test(navigator.userAgent.toLowerCase())
}

function isWeChat () {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
}

function isMqq () {
  return navigator.userAgent.toLowerCase().indexOf(' qq/') !== -1
}

function mobShare (platform = 'weixin', params = {}, callback) {
  const defaults = {
    url: window.location.href,
    title: `质心教育,物理${process.env.VUE_APP_JIANGSAI},生物${process.env.VUE_APP_JIANGSAI},化学${process.env.VUE_APP_JIANGSAI},自主招生全面辅导`,
    pic: 'https://static.eduzhixin.com/images/share/logo.png'
  }
  const data = Object.assign({}, defaults, params)
  window.mobShare.config({
    appkey: MOD_SHARE_KEY,
    params: data,
    callback: callback
  })
  window.mobShare(platform).send()
}

function pageShare (wx, params = {}) {
  const defaults = {
    url: window.location.href,
    title: `质心教育,物理${process.env.VUE_APP_JIANGSAI},生物${process.env.VUE_APP_JIANGSAI},化学${process.env.VUE_APP_JIANGSAI},自主招生全面辅导`,
    desc: `学${process.env.VUE_APP_JIANGSAI}，到质心！`,
    pic: 'https://static.eduzhixin.com/images/share/logo.png'
  }
  const data = Object.assign({}, defaults, params)
  api.weChatShare(data).then(res => {
    if (res.data.result === 1) {
      weChatShare(wx, data)
    } else {
      console.log(res.data.msg)
    }
  }, _ => {
    console.log(_)
  })
}

function weChatShare (wx, params) {
  wx.config({
    debug: false,
    appId: params.appId,
    timestamp: params.timestamp,
    nonceStr: params.noncestr,
    signature: params.signature,
    jsApiList: [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareQZone'
    ]
  })
  wx.error(function (res) {
    console.log(res)
  })
  wx.ready(function () {
    wx.onMenuShareTimeline(params)
    wx.onMenuShareAppMessage(params)
    wx.onMenuShareQQ(params)
    wx.onMenuShareQZone(params)
  })
}

function calcuQuotaText (quota, orderBeginAt, preDays) {
  const now = parseInt(new Date().getTime() / 1000)
  const preSignUp = (orderBeginAt - now) / (60 * 60 * 24) < preDays
  let orderedText = ''
  let orderedStatus = ''
  const restQuota = quota.ordered / quota.total

  if (quota.total === 0 || restQuota === 1 || quota.total - quota.ordered < 0) {
    orderedText = '名额已满'
    orderedStatus = 'fulled'
  } else if (restQuota > 0.9) {
    orderedText = '剩余名额：' + (quota.total - quota.ordered)
    orderedStatus = 'almostFull'
  } else if (quota.total - quota.ordered < 10) {
    orderedText = '剩余名额：' + (quota.total - quota.ordered)
    orderedStatus = 'almostFull'
  } else if (restQuota > 0.7) {
    orderedText = '即将满员'
    orderedStatus = 'almostFull'
  } else {
    orderedText = '正在热报'
    orderedStatus = 'hot'
  }
  if (orderBeginAt) {
    if (orderBeginAt > now) {
      orderedText = '报名未开始' + (preSignUp ? '<span style="color:#fd5353">（可提前报名）</span>' : '')
      orderedStatus = 'notStart'
    }
  }
  return {
    orderedText,
    orderedStatus
  }
}

function convertTimeFormat (second, begin, end, format) {
  if (second === 0) {
    return '无'
  } else {
    const seconds = Number(second) * 1000 + 28800000
    const date = new Date(seconds)
    return date.toISOString().slice(begin, end).replace(/-/g, format).replace('T', ' ')
  }
}

function timeToString (timestamp) {
  const time = new Date(0).setUTCSeconds(timestamp)
  const da = new Date(time)
  const year = da.getFullYear() + '年'
  const month = da.getMonth() + 1 + '月'
  const date = da.getDate() + '日'
  const h = da.getHours() > 9 ? da.getHours() : '0' + da.getHours()
  const mm = da.getMinutes() > 9 ? da.getMinutes() : '0' + da.getMinutes()
  return [year, month, date].join('') + ' ' + h + ':' + mm
}

function clipboard (content, callback) {
  var input = document.createElement('input')
  input.setAttribute('readonly', 'readonly')
  input.setAttribute('value', content)
  document.body.appendChild(input)
  input.select()
  input.setSelectionRange(0, 9999)
  if (document.execCommand) {
    document.execCommand('copy')
    callback()
  }
  document.body.removeChild(input)
}

function easeInCirc () {
  if ($.easing.easeInCirc) return
  $.easing.jswing = $.easing.swing
  $.extend($.easing, {
    easeInCirc: function (x, t, b, c, d) {
      return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b
    }
  })
}

// 加入购物车动画
function ballAnimation ($target) {
  easeInCirc()
  const $endTarget = $('.float-buttons .cart-count')
  const { top, left } = $target.offset()
  const scrollTop = $('body,html').scrollTop() || window.pageYOffset || 0
  const a = document.createElement('div')
  const ball = $(a)
  ball.addClass('shopping-ball transition')
  ball.css({ top: ($target.offset().top - scrollTop), left: $target.offset().left })
  $('body').append(ball)
  ball.show()
  const top1 = $endTarget.offset().top
  const left1 = $endTarget.offset().left
  const xlength = (left - left1) ^ 2
  const ylength = (top - scrollTop - top1) ^ 2
  const abslength = (xlength + ylength) ^ 0.5

  let speed // eslint-disable-line no-unused-vars
  if (abslength >= 430 && abslength <= 820) {
    speed = 500
    ball.addClass('normal')
  } else if (abslength > 820) {
    speed = 600
    ball.addClass('slow')
  } else {
    speed = 400
    ball.addClass('fast')
  }

  ball.animate(
    {
      top: [top1 - scrollTop, 'easeInCirc'],
      left: [left1 - 34, 'linear']
    },
    speed,
    function () {
      ball.remove()
      // $(ballDom).removeClass('shopping-ball transition normal slow fast')
      // $(ballDom).attr('style', '')
    }
  )
}

function hex2int (hex) {
  if (!hex) return 0
  const [len, temp] = [hex.length, []]
  for (let i = 0; i < len; i++) {
    let code = hex.charCodeAt(i)
    if (code >= 48 && code < 58) {
      code -= 48
    } else {
      code = (code & 0xdf) - 65 + 10
    }
    temp[i] = code
  }
  return temp.reduce((acc, c) => {
    return 16 * acc + c
  }, 0)
}

export default {
  isMobile,
  isWeChat,
  isMqq,
  isIOS,
  isAndroid,
  mobShare,
  pageShare,
  calcuQuotaText,
  clipboard,
  convertTimeFormat,
  timeToString,
  ballAnimation,
  hex2int
}
